export type BuyerSummary = {
  id: number;
  name: string;
  country: string;
  url: string | null;
  postal_code: string | null;
  address: string | null;
  town: string | null;
  category: string | null;
  nuts_location: string | null;
  guid: string;
  oscar_id?: number | null;
};
export type EnhancedBuyerData = {
  oscar_category: string[] | null;
  employee_count: string | null;
  annual_spend: string | null;
  location_summary: string | null;
  url: string | null;
};

export enum TenderStage {
  PRE_TENDER = "PRE_TENDER",
  STALE_PRE_TENDER = "STALE_PRE_TENDER",
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  AWARDED = "AWARDED",
}

export const TENDER_STAGE_LABELS: Record<TenderStage, string> = {
  STALE_PRE_TENDER: "Stale pre-tender",
  PRE_TENDER: "Pre-tender",
  OPEN: "Open",
  CLOSED: "Closed",
  AWARDED: "Awarded",
};

export type RecordListSummary = {
  id: number;
  name: string;
  company_id: number;
};

export type UserListSummary = RecordListSummary & {
  count: number;
  owner_id: number;
  guid: string;
};

export type SupplierSummary = {
  id: number;
  name: string;
  country: string | null;
  is_sme: boolean | null;
};

export type Lot = {
  id: number;
  lot_title: string | null;
  lot_number: number | null;
  award_date: string | null;
  value: number | null;
  currency: string | null;
  calculated_expiry: string | null;
  place_of_performance: string | null;
  end_date: string | null;
  start_date: string | null;
  suppliers: SupplierSummary[] | null;
};

export type RecordDetails = {
  guid: string;
  name: string;
  buyer: BuyerSummary;
  href: string;
  country: string;

  value_src: number | null;
  currency: string | null;
  description: string | null;
  url?: string;
  stage: TenderStage;

  close_date: string | null;
  publish_date: string;
  award_date: string | null;
  expiry_date: string | null;

  tenders_received: number | null;
  lots?: Lot[];
  lists?: UserListSummary[];
};
